import React, { Component } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser, addLogs } from "../../actions/authActions";
import utils from "../../utils/functions";
import $ from 'jquery';
import WineScript from "./WineScript";
// import FitnessScript from "./FitnessScript";
import moment from 'moment';
import axios from "axios";
import Language from '../../services/contentData';

class Host extends Component {

  constructor(props) {
    super(props);
    // this.state = {sessionScript: 0};
    this.state = {
      sessionScript: 0,
      timerOn: false,
      timerStart: 0,
      timerTime: 0,
      camera:'',
      microphone:'',
      type : '',
      duration : '',
      counts : '',
      targetZone : '',
      targetBPM : '',
      video : '',
      isTutorialRead:'',
      firstName:'',
      tutorialId:'',
      tutorialStart:''

    };

  }

  addLog = (sessionId, userType, type) => {
    
    this.props.addLogs(sessionId, userType, type);
  };

  /**UPDATE SESSION DATA **/
  tutorialDataUpdate =() => {
    localStorage.setItem('readTutorial', true);
     // $('#walk7').addClass('d-none');
    // $('#letsdo').removeClass('d-none');
    // $('#walk7').addClass('d-none');
    $('#completeTut').addClass('d-none');
    var localstoragedata = JSON.parse(localStorage.getItem('userData'));
    var sessionID = localstoragedata.sessionData.id;
    var tutorialId = localstoragedata.sessionData.isTutorialRead;
    if(tutorialId==1){
          axios.put(process.env.REACT_APP_API_URL+"/api/v1/session/host/updateDefaultSession",{
            "sessionId":sessionID        
          })
        .then(res => {
			
			if ( window['globalAgora'] && window['globalAgora']['agora'] ) { window['globalAgora']['agora'].release(); }
			this.props.history.push("/host");
			
          //console.log("===UPDATETUTORIAL=======response",res);
        }).catch(err =>{
          console.log('----------there is problem------------',err);
      });
    }
  };

   /**UPDATE DATA ON MSTART TUTORILA CLICK BUTTON **/
   startTutorialDataUpdate =() => {
    $('#walk1').removeClass('d-none');
    $("#starttutorial").addClass('d-none');  
    var localstoragedata = JSON.parse(localStorage.getItem('userData'));
    var sessionID = localstoragedata.sessionData.id;
    var tutorialStart = localstoragedata.sessionData.isTutorialStart;

    if(tutorialStart==1){
          axios.put(process.env.REACT_APP_API_URL+"/api/v1/session/host/updateDefaultSessionIstutorialStart",{
            "sessionId":sessionID        
          })
        .then(res => {
          console.log("===UPDATETUTORIAL=======response",res);
        }).catch(err =>{
        console.log('----------there is problem------------',err);
      });
    }
  };
  
  onLogoutClick = e => {
    e.preventDefault();
    this.props.logoutUser();
  };

  joinOnClick = e => {
    e.preventDefault();
    let channel = document.getElementById('channel').value;
    this.props.joinConf(channel);
  };

  zoomVideo = e => {
    let localstoragedata = JSON.parse(localStorage.getItem('userData'));

    if ($('#'+localstoragedata.id).hasClass('zoom-video')) {
      $('#zoom_out_tutorialText').removeClass('d-none'); // Display tutorila message on header
      $('#agora_local').addClass('pointer-none'); //click only one time on zoom
      $('.arrow_down_zoom ').addClass('d-none');
      $('#agora_local_parent').addClass('position-fixed');
      $('.overlay1').css({'z-index':'9999'});
       $('.show-script').removeClass('d-none');
       $('.scrpt1').css({'z-index':'999999'});
       $("#agora_local>div").css({'padding-top':'56.25%'});
        $('#'+localstoragedata.id).removeClass('zoom-video');
        $('#agora_local').addClass('video-streams1');
        $('#agora_local').find('i').addClass('fa-search-plus');
        $('.video_arrow_down').addClass('d-block');
        $('#agora_local').find('i').removeClass('fa-search-minus');
        $('#agora_local').css({"cssText":"min-height: 78% !important; max-height: 62% !important"});
        $('#agora_local video').css({"cssText":"min-width: 180px !important; height: auto !important"});
        $('#click-zoom-host').attr('data-original-title','Zoom my stream view');
        $('.zoom_video_text').addClass('d-none');

    } else {
        $('#'+localstoragedata.id).addClass('zoom-video')
        $('#zoom_in_tutorialText').addClass('d-none');          //display tutorial message on header
        $('#click-zoom-host').addClass('d-none');               //display tutorial message on header        
        // $('#agora_local').addClass('pointer-none');              //display tutorial message on header        
        $('#start_sesstion1').addClass('startsession1');
        $('#start_session_tutorialText').removeClass('d-none'); //display tutorial message on header
        $('#session_strt').removeClass('d-none');               //display tutorial message on header
        $('.overlay1').css({'z-index':'-1'});
        $('.show-script').addClass('d-none');
        $('.scrpt1').css({'z-index':'-1'});
        $("#agora_local>div").css({'padding-top':'0'});
        $('#agora_local').find('i').removeClass('fa-search-plus');
        $('#agora_local').find('i').addClass('fa-search-minus');
        $('.video_arrow_down').addClass('d-none');
        $('.arrow_down_zoom ').removeClass('d-none');
        $('#agora_local_parent').removeClass('position-fixed');
        $('#agora_local').removeClass('video-streams1');
        $('#agora_local').css({"cssText":"min-height: 100% !important; height: 100% !important; max-height: 100% !important"});
        $('#agora_local video').css({"cssText":"min-width: 100% !important; height: auto !important"});
        $('#click-zoom-host').attr('data-original-title','Zoom out my stream view');
        $('.zoom_video_text').removeClass('d-none')
    }
  }

  sendMsgAll = e => {
    $('#msgToAll_button').trigger('click');
  }
  
  loadScript = function (src) {
    var tag = document.createElement('script');
    tag.async = false;
    tag.src = src+"?version="+process.env.REACT_APP_VERSION;;
    
    var body = document.getElementsByTagName('html')[0];
    body.appendChild(tag);
  }

  removeScript = function (src) {
    // function removejscssfile(filename, filetype){
    var targetelement="script" //determine element type to create nodelist from
    var targetattr="src" //determine corresponding attribute to test for

    var allsuspects=document.getElementsByTagName(targetelement);

    for (var i=allsuspects.length; i>=0; i--){ //search backwards within nodelist for matching elements to remove
    if (allsuspects[i] && allsuspects[i].getAttribute(targetattr)!=null && allsuspects[i].getAttribute(targetattr).indexOf(src)!=-1)
        allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    }
  }

  componentDidMount(){

    // if any exception if user has no device on streaming page in any case
    let mediaIds = localStorage.getItem('media-setting');

    if(mediaIds == undefined){
      this.props.history.push('pre-screen');
    }


    $('.dropdown.keep-open').on({
      "shown.bs.dropdown": function() { this.closable = false; },
      "click":             function() { this.closable = true; },
      "hide.bs.dropdown":  function() { return this.closable; }
    });

	if ( window['electron'] )
		{
			this.loadScript('./js/tutorial.js');
			this.loadScript('./js/swiper.min.js');
			this.loadScript('./js/swiper-modifier.js');
		}
	else
		{
			this.loadScript('/js/tutorial.js');
			this.loadScript('/js/swiper.min.js');
			this.loadScript('/js/swiper-modifier.js');
		}

    let localstoragedata = JSON.parse(localStorage.getItem('userData'));
    this.setState({sessionScript: localstoragedata.sessionData.scriptDetail});
    let scDate = localstoragedata.sessionData.scheduleDate;
    this.setState({
      isTutorialRead:localstoragedata.sessionData.isTutorialRead,
      firstName:localstoragedata.firstName
    })

    let currDate = new Date(scDate);
    currDate.setMinutes(currDate.getMinutes() + localstoragedata.sessionData.duration); // adding 330 minutes for matching IST time
    scDate = (new Date(currDate).getTime()) - (new Date().getTime());

    this.state.timerTime = scDate;// 1 sec 1000 = 1sec

    this.startTimer();
    this.sessionTimer(currDate);

    var now = new Date().getTime();
    var scheduleDate = new Date(localstoragedata.sessionData.scheduleDate).getTime();

    if (scheduleDate - now > 0) {
        let x = setInterval(function() {
            var now = new Date().getTime();
            var scheduleDate = new Date(localstoragedata.sessionData.scheduleDate).getTime();
            var t = scheduleDate - now;

            if (t < (localstoragedata.default.startSessionTimer * 1000) && t > 0) {
                $('#start-session').removeClass('d-none');
                clearInterval(x);
            } else if (t < 0) {
                clearInterval(x);
            }
        }, 1000);
    } else {
        $('#start-session').removeClass('d-none');
    }

    this.countdownTimer(localstoragedata.sessionData.scheduleDate);
  }

  componentWillMount(){
    this.removeScript('/pre-main.js');
    this.startTimer();
  }

  sessionTimer = (sessionDate) => {

    let storeData = JSON.parse(localStorage.getItem('userData'));

    var t1 = new Date(sessionDate);
    var t2 = new Date();
    var diff = t1.getTime() - t2.getTime();

    var countdown = Math.floor(diff / 1000);

    //$('.header svg circle').attr("style","animation-duration:"+countdown+"s !important");
    $('.header svg circle').css({"animation":"countdown "+countdown+"s linear infinite forwards", "animation-direction": "reverse"});
    $('.header svg circle').css("stroke", "#9b51e0");
    
    var resetCount1 = setInterval(function() {
      if(countdown <= 0){
        //$('.header svg circle').removeAttr("style");
        //$('.header svg circle').attr("style","animation-play-state:paused");
        $('.header svg circle').css({"animation-play-state":"paused"});
        clearInterval(resetCount1);
      }
      countdown--;
    }, 1000);
  };
  
  startTimer = () => {
    this.setState({
      timerOn: true,
      timerTime: this.state.timerTime,
      timerStart: this.state.timerTime
    });
  };

  testButn =() => {
    window.subscribe()
  };

  countdownTimer(sessionDate) {

      let localstoragedata = JSON.parse(localStorage.getItem('userData'));
      var deadline = new Date(sessionDate).getTime();
      var durationText = 'Time to class :';

      var x = setInterval(function() {
            var now = new Date().getTime(); 
            var t = deadline - now;

            var seconds = ("0" + (Math.floor((t / 1000) % 60) % 60)).slice(-2);
            var minutes = ("0" + Math.floor((t / 60000) % 60)).slice(-2);
            var hours = Math.floor((t / 3600000));
            
            if(hours >= 100) {
              hours = ("0" + hours).slice(-3);
            } else {
              hours = ("0" + hours).slice(-2);
            }

            let time = hours + ' : ' + minutes + ' : ' + seconds;

            if (t >= 0) {
                $('#duration-text').text(durationText);
                $('#countdown-timer-inner-tutorial').text(time);
                $('#overlay-timer-inner').text(time);
            }

            if (t < 0) {

                if (durationText != '') {
                    durationText = '';

                    let seconds = localstoragedata.default.defaultSessionDuration * 60;

                    let currDate = new Date();

                    currDate.setSeconds(currDate.getSeconds() + seconds);
                    deadline = new Date(currDate).getTime();
                } else {
                    clearInterval(x);
                    $('#countdown-timer-inner-tutorial').text('Class Ended');
                }
            }
      }, 1000); 
  }
  
render() {
    const { timerTime, timerStart, timerOn, sessionScript } = this.state;

    const  {user}  = this.props.auth;

    let localstoragedata = JSON.parse(localStorage.getItem('userData'));
    let sessionData = localstoragedata.sessionData;

    let localDate = moment(sessionData.scheduleDate).format('MM/DD/YYYY # h:mm a');
    localDate = localDate.replace('#', 'at');
    let remTime = '';
    let total_limit= localstoragedata.default.maxUserLimit;

    let scriptHtml = '';

    if (sessionScript == 2) {
      scriptHtml = <WineScript />;
    }

    var newulength = JSON.parse(localStorage.getItem('tempUsers')).length;
    newulength = newulength < 1 ? 0 : --newulength ;

    let onlineUsers = '';
    let participent = '';
    let participentTimerPopup = '';

    let tempUsersdata = JSON.parse(localStorage.getItem('tempUsers'));

    let sessionStartDate = moment(sessionData.scheduleDate).format('dddd MMM Do, YYYY');
    let sessionStartTime = moment(sessionData.scheduleDate).format('h:mm A');

    let logo = sessionData.logo;
    var totalTime = sessionData.duration;
    var totalhours = Math.floor(totalTime / 60);          
    var totalMinutes = totalTime % 60;
    var sessionDuration = '';
    var sessionScriptDetail = sessionData.scriptDetail;
    
    if (totalhours >= 1) {
        sessionDuration = sessionDuration + '' + totalhours + ' Hr';
    }

    if (totalMinutes >= 1) {
        sessionDuration = sessionDuration + ' ' + totalMinutes + ' mins';
    }

    onlineUsers = tempUsersdata.map((user, idx) => {
      if(user.userType != 1) {
        const { id, firstName, lastName, image, city } = user;
        return (
          <tr data-position="100000000000000" id={"online-user-row-"+id} key={idx}>
          <th scope="row"><img src={image} /></th>
          <td className="text-left"><span className="welcome-title">{firstName.toLowerCase()} {lastName != null ? lastName.toLowerCase() : ''} {city != null ? ', '+city.toLowerCase() : ''}</span></td>
          <td><img className="mr-2 user-status" src="./images/offline.png" /><span className="user-online-status">offline</span></td>
          <td className="visible-status"><i className="fa fa-check text-green d-none" id={"user-green-status-"+id}></i><i className="fa fa-times text-red" id={"user-red-status-"+id}></i></td>
          <td>5</td>
          </tr>
        );
      }
    })
return (
    <div className="container justify-content-between d-flex flex-column h-100 position-relative tutorialscreen">
    <div className="screen_popup p-4 bg-grayy rounded d-none" id="back-press-alert"><p className="white_hdng mb-0"></p></div>
      <div className="start-tutorial" id="starttutorial" style={{display:"block"}}>
      {/* <div className="start-tutorial" id="starttutorial" style={{display:"block"}}> */}
        <div className="bg-grayy p-4 rounded">
        <p className="text-white font-18">Congratulations {this.state.firstName}, you made it to your tutorial!</p>
          <p className="text-white font-18">Now the fun begins...</p>
          <p className="text-white font-18">Time to make you an expert with the buttons on this screen.</p>
          <p className="text-white font-18">You can use your left or right arrow keys on your remote to go back one step or move forward.</p>
          <p className="text-white font-18">Ready? Press the "Start Tutorial" button below or "Ok" on your remote.</p>
        </div>
        <div className="text-center">
          <button class="ok-btn mt-3"><a href="javascript:void(0)" class="text-white" onClick={this.startTutorialDataUpdate}>Start Tutorial</a></button>
          {/* <button class="ok-btn mt-3"><a href="javascript:void(0)" class="text-white" onClick={e=>{$('#walk1').removeClass('d-none'); $("#starttutorial").addClass('d-none');}}>Start Tutorial</a></button> */}
        </div>
      </div>
      {/**CODE FOR END FINISH BUTTON */}
      <div className="start-tutorial d-none" id="letsdo">
        <div className="bg-grayy p-4 rounded">
          <p className="text-white font-18">Good job! Now let's try a guided practice.</p>
          <p className="text-white font-18">By pressing OK,  you will be getting step by step instructions to try out few important features.</p>
        </div>
        <div className="text-center">
          <button class="ok-btn mt-3" onClick={e=>{
                $('#click-zoom-host').removeClass('d-none'); $('#zoom_in_tutorialText').removeClass('d-none'); $("#overlay").addClass('d-none'); $("#letsdo").addClass('d-none');}}><a href="javascript:void(0)" class="text-white">Ok</a></button>
        </div>
      </div>
      {/***COM"PLETE ALL STEPS */}
      <div className="start-tutorial d-none" id="completeTut">
        <div className="bg-grayy p-4 rounded">
          <p className="text-white font-18"> Well done! you practiced the basic features.</p>
          <p className="text-white font-18">Let's start your class now.</p>
        </div>
        <div className="text-center">
          <button class="ok-btn mt-3" onClick={this.tutorialDataUpdate}><a href="javascript:void(0)" class="text-white" >Start</a></button>
        </div>
      </div>

      {/* :''} */}
      {/* <div className="message-box p-4 text-center text-white font-16" id="infoMsgBxb">                   
        <p className="text-center text-white font-16" id="infoMsgTxt"></p>
    </div> */}
    <header className="header bg-gray mt-0 position-fixed zindex-999">
      <div className="row">
        <div className="col-12 col-md-12 d-flex justify-content-between align-items-center">
          <div className="d-flex pl-2 position-relative zindex">
            <div className="count-box position-relative countdown-logo">
              <div className="countdown">
                <svg>
                  <circle r="39" cx="43" cy="43"></circle>
                </svg>
                <a href="javascript:void(0)" className="host-logo logo">
                  <img src="./images/v-logo.png" />
                </a>
              </div>              
            </div>
            <div className="show-hide-v d-none">
              <div>
                <a href="javascript:void(0)" className="back-btn"><i className="fa fa-chevron-left" aria-hidden="true"></i></a>
                <img src="./images/v-logo.png" />
              </div>
            </div>
            <div className="ml-4">
             <h3 className="main-heading show-hide-title d-block">{sessionData.name} <br />
              <span>by <span className="welcome-title">{sessionData.hostFirstName.toLowerCase()} {sessionData.hostLastName.toLowerCase()}</span>
              <span className="green-online online-status"><span>ONLINE</span></span></span>          
             </h3>
            </div> 
          </div>     
          <div class="flex-grow-1 position-relative mx-2 h-100" id="show_tutorial_msg">
            <div class="tutorial_txt_box p-3 d-none" id="zoom_in_tutorialText">
              <p>Let’s start by pressing the Zoom button for your local video stream. Use this feature at the start of every class to make sure the camera is able to capture the positions of your body that you want your clients to view during the class.</p>
            </div>
            <div class="tutorial_txt_box p-3 d-none" id="start_session_tutorialText">
              <p>Fifteen seconds before the class starts, Virdio will display a message "Class is about to start. Press the Start Class button to allow your clients to join the virtual studio". As soon as you are ready to begin the class, press the Start Class button to allow your clients to join the virtual studio</p>
            </div>
            {/*** step 3a this messge is show for start script */}
            <div class="tutorial_txt_box p-3 d-none" id="playsession_tutorialText">
              <p>Once you are ready to start the workout, press the START button to start the workout script</p>
            </div>
            {/**STEP 2b message not call */}
            <div class="tutorial_txt_box p-3 d-none" id="raiseHand_tutorialText">
              <p>Once you press Start Class button, anyone waiting for the class to start will begin to appear on your screen. If you have more than 8 clients in your class, only 8 will show at one time on the screen. Virdio will ensure at preset intervals to swap clients in-and-out to make sure everyone gets equal screen time.</p>
              </div>
             {/** STEP 3b this messge pause script  */}
             <div class="tutorial_txt_box p-3 d-none" id="pausesession_tutorialText">
              <p>Once the workout script has started, all members in the class with have synchronized countdown clocks. Click in the "Chest Stretch" highlighted area to continue.</p>
            </div>

              {/** STEP 4a_2 after hand raise script message */}
              <div class="tutorial_txt_box p-3 d-none" id="raisehand1_tutorialText">
              <p>When a member has a question, they will press the Hand Raised button on their screen.  If that member's video stream is not currently showing on your screen, you will see the Hand Raised here.  By pressing the Hand Raised button on your remote, you will see a list of all members who are not on the screen and have raised their hand.</p>
            </div>

              {/** STEP 4b_1  click on dropdown message  */}
              <div class="tutorial_txt_box p-3 d-none" id="raisehanddropdown_Text">
              <p>You can scroll down the list and click on their name to swap them on to the screen.</p>
            </div>

            {/** STEP 4b_2  select Participant message  */}
            <div class="tutorial_txt_box p-3 d-none" id="selectPaticipant_Text">
              <p>Using the Up and Down Arrow keys on your remote, scroll to the member you want to swap in to have a conversation.  Press the “Ok” button on your remote to swap them in.</p>
            </div>

            {/** STEP 4a_1  select Participant message  */}
             <div class="tutorial_txt_box p-3 d-none" id="4a1_Text">
              <p>When a member has a question, they will press the Hand Raised button on their screen.  If that member's video stream is not currently showing on your screen, you will see the Hand Raised here.  By clicking on the Hand Raised button, you will see a list of all members who are not on the screen and have raised their hand.</p>
            </div>

            {/** STEP 4a_2  select Participant message  */}
            <div class="tutorial_txt_box p-3 d-none" id="4b1_Text">
              <p>You can scroll down the list and click on their name to swap them on to the screen.</p>
            </div>

             {/** STEP 4c_1  select Participant message  */}
             <div class="tutorial_txt_box p-3 d-none" id="4c1_Text">
              <p>Once they are on the screen they can talk to you freely.  When you are done with the conversation, click on the stream to end the conversation.</p>
            </div>

             {/** STEP 4c_2  select Participant message  */}
             <div class="tutorial_txt_box p-3 d-none" id="4c2_Text">
              <p>Using the Up and Down Arrow keys on your remote, scroll to the member you want to swap in to have a conversation.  Press the “Ok” button on your remote to swap them in.</p>
            </div>

            {/** STEP5a   handraise on Participant message  */}
            <div class="tutorial_txt_box p-3 d-none" id="5a_Text">
              <p>When a member has a question, they will press the Hand Raised button on their screen.  If that member's video stream is currently showing on your screen, you will see the Hand Raised at the top left corner.  By clicking on their stream, the Hand Raised will switch to a microphone so you can hear them.</p>
            </div>
            {/** STEP5b   handraise on Participant message  */}
            <div class="tutorial_txt_box p-3 d-none" id="5b_Text">
              <p>Once your conversation with the member is over, click on the stream again to turn off the microphone and un-highlight the stream.</p>
            </div>

             {/** STEP 6a  on Participant message  */}
             <div class="tutorial_txt_box p-3 d-none" id="6a_Text">
              <p>Click on this member stream to Select the stream.</p>
            </div>            

            {/** STEP 6b on Participant message  */}
            <div class="tutorial_txt_box p-3 d-none" id="6b_Text">
              <p>Once the member is Selected, they can talk to you and you can zoom their video stream by clicking the Zoom button.  Click on the stream to unselect the stream.</p>
            </div>

             {/** STEP last complete tutorial message  */}
             <div class="tutorial_txt_box p-3 d-none" id="complte_Text">
              <p>Thank you, you have completed all steps in the tutorial Press the "Start" button or Press the “Ok” button on your remote and redirect to Our Instructor Streaming Panel.</p>
            </div>



          </div>
          <div className="position-relative zindex">
             <div className="time text-right">  {/*<span>{localDate}</span>*/}
                {/*<span className="countdown-timer">Time Remaining: {hours} : {minutes} : {seconds}</span>*/}
                <span className="countdown-timerr"><span id="countdown-timer-inner-tutorial"></span></span>
                <div id="errmsg"  className="d-none" style={{color:'green'}}></div>
                <div id ="all_attendies_list"></div>
              </div>
              <div className="">
                
                <div className="justify-content-end d-flex align-items-center mt-1 height-56">

                  {/**SHOW HIDE INSTRUCTION FRAME */}                 
                
                  {/* <div className="text-center position-relative" id="startsession1"> */}
                  <div className="text-center position-relative" id="start_sesstion1">
                  <div className="parent-session1 position-absolute cursor-pointer d-none" id="session_strt"  onClick={e=>{
                   $('#playsession_tutorialText').removeClass('d-none'); $('#border_box_start').removeClass('d-none'); $('#play-slider').removeClass('d-none'); $('#mute-unmute-all').removeClass('d-none'); $("#start_sesstion1").addClass('d-none'); $("#start_session_tutorialText").addClass('d-none'); $('#hand_microphone').removeClass('d-none'); $('#img_group1').removeClass('d-none'); $('#playBtn').removeClass('d-none');}}>
                    <img src="./images/union-up.png" className="arrow_down" />
                  </div>
                    <a className="custom_button1" href="javascript:void(0)" tabIndex="1">
                      <img src="./images/start_session.png" className="" /></a>
                    <p className="text-center mb-0 text-white font-14">Start Class</p>
                  </div>              

                  <div className="text-center header_btn_cnt d-none" id="mute-unmute-all">
                    <a className="btn position-relative  custom_button1 pr-20" href="javascript:void(0)" tabIndex="1" data-toggle="tooltip" title="Allow everyone to talk">

                      <img src="./images/mute.png" />
                    </a>
                    <p className="text-center  mb-0 text-white font-14">Mute/Unmute</p>
                  </div>
                {(
                    ()=>{
                        if(sessionData.groupId == 1) {
                            {/*return <a className="btn  btn-primary border-right" href="javascript:void(0)" data-toggle="modal" data-target="#fitness-ssession-details" tabIndex="1">Details</a>;*/}
                            return <div className="text-center header_btn_cnt" data-toggle="tooltip" title="Class Details">
                              <a className="custom_button1" id="session-details" href="javascript:void(0)" data-toggle="modal" data-target="#fitness-ssession-details" tabIndex="1">
                                <img src="./images/list.png" className="" /></a>
                              <p className="text-center mb-0 text-white font-14">Details</p>
                            </div>;                            
                        } else if(sessionData.groupId == 2) {
                            {/*return <a className="btn  btn-primary border-right pr-20" href="javascript:void(0)" data-toggle="modal" data-target="#show-details2" tabIndex="1">Details</a>;*/}
                            return <div className="text-center header_btn_cnt" data-toggle="tooltip" title="Class Details">
                              <a className="custom_button1" id="session-details" href="javascript:void(0)" tabIndex="1" data-toggle="modal" data-target="#show-details2">
                                <img src="./images/list.png" className="" /></a>
                              <p className="text-center mb-0 text-white font-14">Details</p>
                              
                            </div>;
                        }
                    }
                )()}
                   <div className="text-center header_btn_cnt position-relative" data-toggle="tooltip" title="Leave the Class">
                    <a className="custom_button1" href="javascript:void(0)" tabIndex="1">
                      <img src="./images/close.png" />
                    </a>
                    <p className="text-center  mb-0 text-white font-14">Close</p>
                    </div>
                </div>
               
              </div>
          </div>   
          <div id="guestmsg" className="d-none" style={{color:'green'}}></div>                      
            
          <div className="text-danger" style={{color:'#fff'}} id="exptn-errors"></div>
        </div>
      </div>     
    </header>
    <div className="walk-1 d-none" id="walk1">
      <div className="small_txt bg-dark rounded text-right py-2 px-3 position-relative">
        <p className="text-white main_pop_text py-0 d-inline-block">
        <span class="badge">1</span>         
        <div className="time text-right">        
        <span className="countdown-timerr pr-0">
          {/* <span id="duration-text" className="pr-0"></span> */}
          <span id="overlay-timer-inner" className="pl-0"></span>
        </span>
        </div>
        </p>
        <div className="mt-0 d-flex justify-content-center">
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/start_session.png"/>
            <span class="badge">2</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/mute.png"/>
            <span class="badge">3</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/list.png"/>
            <span class="badge">4</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center" id="walk8_close" onClick={e=>{
               $("#walk8").addClass('d-none');$("#overlay").addClass('d-none'); }}>
            <img src="./images/close.png"/>
            <span class="badge">5</span>
          </div>
          {/* <div className="text-right main_pop_text align-self-center mx-2 mb-0 position-relative"><a className="text-light cursor-pointer" id="walk8_close" onClick={e=>{
               $("#walk8").addClass('d-none');$("#overlay").addClass('d-none'); }}>&times;</a><span class="badge">5</span></div> */}
        </div>

        <div class="popover1">
        {/* <div className="text-right"><a className="text-light cursor-pointer" id="walk1_close"  onClick={e=>{
               $("#walk1").addClass('d-none');$("#overlay").addClass('d-none'); }}>&times;</a></div> */}
          <div class="arrow_small"></div>
          <div class="pop-content">
            <ol className="popup-list pr-3 font-18 mb-0">
              <li className="mb-2">Time left in the Class</li>
              <li className="mb-2">Allow all members waiting into the Virtual Studio</li>
              <li className="mb-2">By default the members in the class cannot speak freely, you can explicitly allow them to do so. When this button is pressed, it allows all members to speak freely. Pressed a second time, disables their ability  to speak freely. You can repeat this as many times as you like during a class.</li>             
              <li className="mb-2">Class Details</li>
              <li className="mb-2">Leave the Class</li>
            </ol>
              <p className="d-flex justify-content-between mb-0">
              <span className="black_button d-none"></span>
                <a href="javascript:void(0)" className="black_button" onClick={e=>{
                $('#walk1').addClass('d-none');$("#starttutorial").removeClass('d-none'); }}>Back</a>
                <a href="javascript:void(0)" className="black_button" onClick={e=>{
                $('#walk3').removeClass('d-none'); $("#walk4").removeClass('d-none'); $("#walk1").addClass('d-none'); }}>Next</a></p>
          </div>
        </div>
      </div>
    </div>
    
    <section className="bg-gray px-0 py-1 rounded section attendees mysec position-relative" id="">
      <div className="row px-0 px-sm-3 pb-2 pt-1 justify-content-between align-items-center">
        <div className="col-6 col-md-6 d-flex align-items-center">
          <h4 className="title">Member View (<span>0</span>/<span>0{/*newulength*/}</span>)</h4>
          <span className="d-inherit position-relative">
            <a href="" className="move-list"  id="">
              <img src="./images/move-list.png" />
              <p className="text-center mb-0 text-white font-14">List</p>
            </a>
            <div className="walk-2 d-none" id="walk3">                    
              <div className="small_txt bg-dark rounded py-2 position-relative">
                <div className="d-flex justify-content-center">
                  <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
                  <img src="./images/move-list.png" />
                    <span class="badge">1</span>
                  </div>
                  <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
                  <img src="./images/hand.png" />
                    <span class="badge">2</span>
                  </div>
                 
                </div>    
                <div class="popover1">
                {/* <div className="text-right"><a className="text-light cursor-pointer" id="walk3_close" onClick={e=>{$("#walk3").addClass('d-none');$("#overlay").addClass('d-none'); }}>&times;</a></div> */}
                  <div class="arrow_small"></div>
                  <div class="pop-content">
                  <ol>
                      <li className="px-2 font-18">See a list of all members in the class.</li>
                      <li className="px-2 font-18">If a member who is not visible on the screen raises their hand, this icon appears on the screen. You can click on the icon to see their names. One by one you can highlight them and select them; at which time they will replace someone on the screen, and they can ask their question.</li>
                      <li className="px-2 font-18">Make Member area bigger.</li>
                    </ol>
                    <p className="d-flex justify-content-between mb-0">
                      <a href="javascript:void(0)" className="black_button" onClick={e=>{$("#walk1").removeClass('d-none');
                      $("#walk4").removeClass('d-none'); $("#walk3").addClass('d-none'); }}>Back</a>
                      <a href="javascript:void(0)" className="black_button" onClick={e=>{$("#walk6").removeClass('d-none');$("#walk3").addClass('d-none'); $("#walk4").addClass('d-none'); }}>Next</a></p>
                  </div>
                </div>
              </div>
            </div>
          </span>
          {/* <a href="" className="move-list text-center">
            <img src="./images/swipe-list.png" />
            <p className="text-center mb-0 text-white font-14">Swap In</p>
          </a> */}
          {/* <a href="" className="move-list1" onClick={this.showpart.bind(this)}><img src="./images/swipe-list.png" /></a> */}
          {/* <a href="" className="move-list"><img src="./images/swipe-list.png" /></a> */}
          <div className="hand-raise-list position-relative">
            <div className="dropdown position-relative">
            <div class="text-center hand_btn_cnt position-relative d-none" id="handraise_icon"  onClick={e=>{
              $("#4a1_Text").removeClass('d-none'); $("#5b_Text").addClass('d-none'); $("#dropdownmenuitem11").addClass('d-block');$('#handraiseArrow').addClass('d-none');
            }}>
              <img src="./images/union1.png" className="union_right" id="handraiseArrow"/>
              <a class="custom_button1" id="session-details" href="javascript:void(0)" tabindex="1">
                <img src="./images/hand.png" class="" />
              </a>
              <p class="text-center mb-0 text-white font-14">Raised</p>
            </div>
              <div className="dropdown-menu cursor-pointer" id="dropdownmenuitem11" onClick={e=>{ $("#4b1_Text").removeClass('d-none'); $("#4a1_Text").addClass('d-none');$("#dropdownmenuitem11").removeClass('d-block'); $("#raisehand1_tutorialText").addClass('d-none'); $("#microphone_icon_t").removeClass('d-none'); $("#hand_icon_right").removeClass('d-none'); $("#subscribe_list1").addClass('purple-border d-none'); $("#subscribe_group3").addClass('purple-border'); $("#subscribe_group3").removeClass('d-none'); $('#handraise_icon').addClass('d-none'); $("#complte_Text").removeClass('d-none'); $("#slct_partipant_dwn_arrow").removeClass('d-none');}}>
              <img src="./images/union-right.png" className="union-right" />
                <div className="raised-hands">
                  <h4>Raised Hands (<span id="">1</span>)</h4>
                  <i className="fa fa-times"></i>
                </div>
                <div className="" id="">
                  <div className="d-flex">
                    <div className="align-self-start"><img src="./images/Group-2.png" /></div>
                    <div><p className="white-text font-20 mb-0">Michelle, LA</p><p className="white-text font-20">2 mins ago</p></div>
                  </div>
                </div>               
              </div>
            </div>
          </div>
          
        </div>
        <div className="col-6 col-lg-3 col-md-4 col-sm-5 attendy-fullscreen attendy-fullscreen">
          {/* <button type="button" className="btn btn-outline-secondary float-right mt-1 show-hide-footer-panel mr-3">"Show Attendees"</button> */}
          {/* <a className="fullscreen" href="javascript:void(0)" id="fullscreen"><img src="./images/full-screen.png" /></a> */}
          <a className="fullscreen text-center position-relative" href="javascript:void(0)" id="fullscreen" data-toggle="tooltip" title="Increase the area of streaming section">
            <img src="./images/full-screen.png" />
            <p className="text-center mb-0 text-white expnd font-14">Expand</p>           
          </a>
          <div className="walk-1 walk-wd d-none" id="walk4">                    
              <div className="small_txt position-relative">
                <div className="main_pop_text p-2">
                  <img src="./images/full-screen.png" />
                  <span class="badge">3</span>
                </div>
                
               {/*****USE FOR PARTICIPANT LISTS TUTORIAL */}
    <div className="walk-4 d-none py-3 d-none" id="walk5">
    <span class="badge">2</span>                    
      <div className="small_txt mx-auto bg-dark rounded px-3 py-2 position-relative">
        <div className="d-flex justify-content-center group">
          <div className="mx-2 position-relative">
            <img src="./images/g1.png" className="w-100" />
            <div className="pop_text position-absolute d-flex justify-content-center align-items-center">
              <img src="./images/hand.png" />
              <span class="badge">1</span>
             </div>   
          </div>
          <div className="mx-2">
            <img src="./images/g2.png" className="w-100" />
          </div>
            
        </div> 
        <div class="popover1">   
        <div class="arrow_small"></div>
          <div class="pop-content">
          <ol className="popup-list pr-3 font-18 mb-0">
              <li className="mb-2">If a member on the screen raises their hand, you will see the hand icon on the top right. If you click on their stream, their microphone is opened and they can ask their question, everyone else on the class can hear them too.  If you click on their stream again, their microphone is turned off.</li>
              <li className="mb-2">You can have up to 8 streams on the screen at one time. If your class has more than eight members, we swap them in and out, giving everyone equal screen time</li>
          </ol>            
            <p className="d-flex justify-content-between mb-0">
              <a href="javascript:void(0)" className="black_button" onClick={e=>{$("#walk3").removeClass('d-none');$("#walk5").addClass('d-none'); }}>Back</a>
              <a href="javascript:void(0)" className="black_button" onClick={e=>{$("#walk6").removeClass('d-none'); $("#walk5").addClass('d-none'); }}>Next</a></p>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
  </div>
</div>
      
    <div className="row one-gutters justify-content-center align-items-center subsc" id="subscribers-list">
      <div className="group1 mx-2 position-relative d-none" id="hand_microphone">

        <img src="./images/union.png" class="arrow_down d-none" id="slct_partipant_dwn_arrow"/>
        <img src="./images/group2.png" className="radius-10 cursor-pointer" id="subscribe_list1" onClick={e=>{ $("#subscribe_list1_1").removeClass('d-none');  $("#subscribe_list1").addClass('d-none'); $("#6b_Text").removeClass('d-none'); $("#6a_Text").addClass('d-none'); }}/>

        <img src="./images/group1_1.png" className="radius-10 cursor-pointer d-none" id="subscribe_list1_1" onClick={e=>{ $("#subscribe_list1_1").addClass('d-none'); $("#subscribe_list1").removeClass('d-none'); $("#img_group1").removeClass('d-none'); $("#slct_partipant_dwn_arrow").addClass('d-none'); $("#hand_icon_p").removeClass('d-none'); $("#img_grp_1").addClass('purple-border'); $("#5a_Text").removeClass('d-none'); $("#6b_Text").addClass('d-none');}}/>

        <img src="./images/group3.png" className="radius-10 cursor-pointer d-none" id="subscribe_group3" onClick={e=>{$("#img_group1").removeClass('purple-border'); $("#hand_microphone_pt").addClass('d-none');  $("#completeTut").removeClass('d-none'); $('#subscribers-list').addClass('d-none'); }}/>
       <div className="hand-icon-left d-none" id="hand_icon_t">
        
         {/* <img src="./images/voice-commands.png" className="width-20 d-none" id="voice_command_t" onClick={e=>{ $("#hand_microphone").removeClass('purple-border'); $("#microphone_icon_t").addClass('d-none'); }}/>*/}
         <img src="./images/hand.png" className="width-20 d-none" id="hand_icon_left"/> 
         <img src="./images/union.png" class="arrow_down" id="microphone_dwn_arrow" />
         </div>
         <div className="hand-icon-right d-none" id="hand_icon_right">
         
         {/* <div class="parent-session position-absolute"></div> */}
         <i className="fa fa-search-plus"></i>
         </div>
         <div className="highlight_text" id="hand_icon_text">Michelle</div>
       <div className="hand-icon-left d-none" id="microphone_icon_t">
        
       <img src="./images/voice-commands.png" className="width-20"/></div>
    </div>
    <div className="group1 radius-12 position-relative mx-2 d-none" id="img_group1" >  
        <img src="./images/group1.png" className="radius-10" id="img_grp_1"/>
        <div className="hand-icon-left cursor-pointer d-none" id="hand_icon_p" >        
        <img src="./images/union.png" class="arrow_down" />
          <img src="./images/hand.png" className="width-20" id="hand_img_grp1" onClick={e=>{$("#hand_img_grp1").addClass('d-none'); $("#hand_microphone_pt").removeClass('d-none'); $("#slct_partipant_dwn_arrow").addClass('d-none'); $("#5b_Text").removeClass('d-none'); $("#5a_Text").addClass('d-none');}}/>
          <div className="hand-icon-right_grp1" id="hand_icon_right">
         <i className="fa fa-search-plus"></i>
         </div>
        </div>
        <div className="hand-icon-left cursor-pointer d-none" id="hand_microphone_pt" onClick={e=>{$("#hand_microphone_pt").addClass('d-none'); $("#img_grp_1").removeClass('purple-border');  $("#hand_icon_p").addClass('d-none'); $("#handraise_icon").removeClass('d-none'); }}>       
        <img src="./images/voice-commands.png" className="width-20" id="microphone_icon_p" /> 
        </div>
         <div className="highlight_text_group1" id="hand_icon_text">Amanda</div></div>
    </div>

    {/**USE MICROPHONE, SWITCH CAMERA, RECORDING & ZOOM  LICAL STREAMING */}
    <div className="walk-2 d-none" id="walk6">
      <div className="small_txt bg-dark rounded px-2 py-2 position-relative">
        <div className="d-flex">
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/voice-commands.png"/>
            <span class="badge">1</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/music-icon.png"/>
            <span class="badge">2</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/reverse-cam.png"/>
            <span class="badge">3</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/stop2.png"/>
            <span class="badge">4</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <i className="fa fa-search-plus" aria-hidden="true"></i>
            <span class="badge">5</span>
          </div>
        </div>

        <div class="popover2">
        {/* <div className="text-right"><a className="text-light cursor-pointer" id="walk1_close"  onClick={e=>{
               $("#walk1").addClass('d-none');$("#overlay").addClass('d-none'); }}>&times;</a></div> */}
          <div class="arrow1"></div>
          <div class="pop-content">
            <ol className="popup-list pr-3 font-18">
              <li className="mb-2">You can mute your local microphone so no one on the class can hear you.</li>
              <li className="mb-2">Manage your playlist (Coming Soon).</li>
              <li className="mb-2">Switch camera used to capture your video.</li>
              <li className="mb-2">Record the class.</li>
              <li className="mb-2">Zoom your local video stream so you can make sure you are visible in the video to your members.</li>
              </ol>
              <p className="d-flex justify-content-between mb-0">
                <a href="javascript:void(0)" className="black_button" onClick={e=>{
                $('#walk3').removeClass('d-none');$("#walk6").addClass('d-none'); }}>Back</a>
                <a href="javascript:void(0)" className="black_button" onClick={e=>{
                $('#walk7').removeClass('d-none');$("#walk6").addClass('d-none'); }}>Next</a></p>
          </div>
        </div>
      </div>
    </div>
    {/**USE START, PAUSE & STOP SCRIPT */}
    <div className="walk-3 d-none" id="walk7">
      <div className="small_txt bg-dark rounded px-2 py-2 position-relative">
        <div className="d-flex">
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/play.png"/>
            <span class="badge">1</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/pause.png"/>
            <span class="badge">2</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/stop.png"/>
            <span class="badge">3</span>
          </div>
          <div className="main_pop_text mx-1 py-1 mb-0 d-flex justify-content-center align-items-center">
            <img src="./images/showscript.png"/>
            <span class="badge">4</span>
          </div>
        </div>

        <div class="popover1">
        {/* <div className="text-right"><a className="text-light cursor-pointer" id="walk1_close"  onClick={e=>{
               $("#walk1").addClass('d-none');$("#overlay").addClass('d-none'); }}>&times;</a></div> */}
          <div class="arrow1"></div>
          <div class="pop-content">
            <ol className="popup-list pr-3 font-18 mb-0">
              <li className="mb-2">Start script.</li>
              <li className="mb-2">Pause script.</li>
              <li className="mb-2">Stop script.</li>
              <li className="mb-2">View Workout Details.</li>
              </ol>
              <p className="d-flex justify-content-between mb-0">
                <a href="javascript:void(0)" className="black_button" onClick={e=>{
                $('#walk6').removeClass('d-none');$("#walk7").addClass('d-none'); }}>Back</a>
                <a href="javascript:void(0)" className="black_button" onClick={e=>{$('#walk7').addClass('d-none'); $('#letsdo').removeClass('d-none');}}>Finish</a></p>
          </div>
        </div>
      </div>
    </div>

    </section>
    <div className="row position-fixed host-script-section align-items-end justify-content-between het" id="agora_local_parent">
    
      <div className=" host-section d-flex flex-direction-column h-100">
        <div className="host-local">
          <div className="add-remove-round1 host-show-hide px-3 bg-gray pt-0 pb-1 h-100 top-rounded bottom-rounded flex-grow-1 d-block">
          <div className="add-remove-round1 position-relative add-remove-height height-53 bg-gray ht-20 top-rounded d-flex flex-wrap justify-content-between align-items-center">
          
            <h3 className="main-heading font-size-17 float-left">Streaming</h3>
            <div className="host-header d-flex justify-content-between">
              <a className="custom_button2 text-center mr-3" href="javascript:void(0)" id="mute-unmute-local1">
                <img src="./images/voice-commands.png" className="unmute-icon" id="mute-unmute-local" />
                <p className="text-center mb-0 text-white font-8">Mic</p>
              </a>
              <span className="d-inherit" data-toggle="tooltip" title="Manage Class Playlist">
                <a className="custom_button2 text-center mr-3" href="javascript:void(0)" id="playlist">
                  <img src="./images/music-icon.png" className="music-icon" />
                  <p className="text-center mb-0 text-white font-8">Playlist</p>
                </a>
              </span>
              <span className="d-inherit"><a className="custom_button2 text-center mr-3" href="javascript:void(0)" data-target="#switch-camera-popup" id="switch-camera">
                <img src="./images/reverse-cam.png" className="video-icon" />
                <p className="text-center mb-0 text-white font-8">Camera</p>
              </a></span>
              <a className="custom_button2 text-center start_btn" href="javascript:void(0)" id="btn-start-recording">
                <img src="./images/circle.png" className="circle-icon mr-0" />
                <p className="text-center mb-0 text-white font-8">Start</p>
              </a>
              <a className="custom_button2 text-center d-none stop_btn" href="javascript:void(0)" id="btn-stop-recording">
                <img src="./images/stop2.png" className="circle-icon mr-0" />
                <p className="text-center mb-0 text-white font-8">Stop</p>
              </a>
            </div>
          </div>
        
          <div id={localstoragedata.id} className="video-holder-host h-100 overflow-inherit">
         
              <div className="zoom-box h-100">
              <img src="./images/union-up.png" className="arrow_down_zoom d-none" />
              <p className="zoom_video_text d-none" id="zoom_out_tutorialText">Once you have made sure that the camera is capturing you as you desire, press the minimize button to return to normal.              
              </p>
                <div id="agora_local" className="video-streams video-streams1 ht-80">
                  <video id="local_preview" autoplay playsinline></video>
                  <small className="click-recoring_gif d-none" id="recoding_session">
                   <img src="./images/record_progress.gif" className="text-center mb-0 text-white font-8" style={{width:13, height:17}}/>
                  </small>
					<p className="border_box1 position-absolute d-none" id="click-zoom-host" onClick={this.zoomVideo.bind(this)}><img src="./images/union.png" className="video_arrow_down" /></p>

					<small className="click-zoom" id="click-zoom-host" onClick={this.zoomVideo.bind(this)}>
						<i className="fa fa-search-plus" aria-hidden="true"></i>
					</small>
				
                  <small className="click-zoom" id="click-zoom-host" onClick={this.zoomVideo.bind(this)} data-toggle="tooltip" title={Language.zoomtooltips}>
                    <i className="fa fa-search-plus" aria-hidden="true"></i>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <video style={{width:0}}></video>
      <div className="test-script fitness-script h-100 position-relative">
      
      <div className="h-100">
        <div id="" className=" script-info h-100">
          <div className="h-100">
            
          { localstoragedata.sessionData.displayScript == 1 ? (<div className="d-flex height-script h-100 justify-content-end flex-direction-column position-relative">
              <div className="animate-display ht-20 bg-gray position-relative top-rounded py-1 d-flex justify-content-between align-items-center px-3 add-remove-round ">
                <h3 className="main-heading font-size-17">Fitness Script <span className="ml-md-4 font-size-16"><span id="fitness-counter">0</span>/{sessionScript.length} {localstoragedata.sessionData.scriptType}</span><span id="script_name" className="script_name"></span><span id="script_time" className="script_time"></span></h3>
                <div className="pt-2 d-flex">
               
                <div className="text-center mx-2 position-relative cursor-pointer" id="play-slider" data-toggle="tooltip" title="Start workout script">
                  <div className="parent-session position-absolute d-none" id="playBtn" onClick={e=>{$('#play-slider').addClass('d-none'); $('#playsession_tutorialText').addClass('d-none'); $('#pausesession_tutorialText').removeClass('d-none'); $('#border_box_start').removeClass('border_box2'); $('#playStartBox').removeClass('swiper-start'); $('#pause-slider').removeClass('d-none'); $('#playNext').addClass('swiper_slide_nxt'); $('#playNext').removeClass('pointer-none'); $('#pause_arrow').removeClass('d-none');}}>
                    <img src="./images/union.png" className="arrow_down" /></div>                  
                    <a href="javascript:void(0)" className="play-pause-btn">
                      <img src="./images/play.png" />                    
                    </a>
                    <p className="text-center mb-0 text-white font-8">Start</p>
                </div>
                <div className="text-center mx-2 position-relative d-none" id="pause-slider" data-toggle="tooltip" title="Pause workout script">
                    <a href="javascript:void(0)" className="play-pause-btn">
                      <img src="./images/pause.png" />                    
                    </a>
                    <p className="text-center mb-0 text-white font-8">Pause</p>
                </div>

                {/* <a href="javascript:void(0)" className=" mr-2 stop-btn" id="stop-slider"><img src="./images/stop.png" /></a> */}
                <div className="text-center mx-2 position-relative" id="stop-slider-parent" data-toggle="tooltip" title="Stop and go to start of script"><button className="stop-btn" id="">
                  <img src="./images/stop.png" />                    
                </button>
                <p className="text-center mb-0 text-white font-8">Stop</p>
                </div>
              
                <div className="text-center mx-2 position-relative" data-toggle="tooltip" title="View script details">
                  <div className="show-script">
                    <a href="javascript:void(0)" data-toggle="modal" data-target="#fitness-script" tabIndex="1" className="show-fitness-script" id="fitnesScript">
                    <img src="./images/showscript.png" />                    
                    </a>
                    <p className="text-center mb-0 text-white font-8">Script</p>
                  </div>
                </div>
              </div>
              </div>
            
            <div className="bg-gray ht-80 bottom-rounded px-3 pb-2 item-description d-block script-section mt--1 flex-grow-1">
              <div className="h-100"  id="start-fitness" >
              <div className="row h-100 px-3">
                  <div className="swiper-container swiper-container-host">
                    <div className="swiper-wrapper">
                      <div className="swiper-slide mx-2 start position-relative cursor-pointer" id="playStartBox">
                        <p class="border_box2 position-absolute d-none" id="border_box_start" onClick={e=>{$('#playBtn').addClass('d-none'); $('#playsession_tutorialText').addClass('d-none'); $('#pausesession_tutorialText').removeClass('d-none'); $('#border_box_start').removeClass('border_box2'); $('#playStartBox').removeClass('swiper-start'); $('#pause_arrow').removeClass('d-none'); $('#playNext').removeClass('pointer-none'); $('#playNext').addClass('swiper_slide_nxt');}}>
                          <img src="./images/union.png" className="arrow_down" /></p>
                        <span className="countdown-number d-none">0</span>
                        <span id="host_slider_ftnes">
                          <button id="hostFtnsScript">Start</button>
                        </span>
                      </div>
                      <div className="swiper-slide mx-2 pointer-none" id="playNext" onClick={e=>{$('#playNext').removeClass('swiper_slide_nxt'); $('#pausesession_tutorialText').addClass('d-none'); $('#pause_arrow').addClass('d-none'); $('#6a_Text').removeClass('d-none'); $('#handraise_icon').addClass('d-none'); $('#slct_partipant_dwn_arrow').removeClass('d-none'); }}>
                      <img src="./images/union.png" className="arrow_down d-none" id="pause_arrow" />
                        <div className="data-slide">
                          <div className="count-box">
                            <h4 className="scriptName">Chest Stretch</h4>                            
                            <div className="countdown countdown_tutorial">                            
                               <div className="countdown-number">15</div>
                              <svg>
                                <circle r="39" cx="43" cy="43"></circle>
                              </svg>                              
                            </div>
                            <div className="row fitness-info justify-content-center">                           
                                 <div className="border-right-none">
                                  <div className="target-info d-flex justify-content-center align-item-center">
                                    <span className="">TARGET BPM </span><span className="mt-0">90</span>
                                  </div>
                                </div>                           
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide mx-2">
                        <div className="data-slide">
                          <div className="count-box">
                            <h4 className="scriptName">Shoulder Stretch</h4>                            
                            <div className="countdown countdown_tutorial">                            
                               <div className="countdown-number">30</div>
                              <svg>
                                <circle r="39" cx="43" cy="43"></circle>
                              </svg>                              
                            </div>
                            <div className="row fitness-info justify-content-center">                           
                                 <div className="border-right-none">
                                  <div className="target-info d-flex justify-content-center align-item-center">
                                    <span className="">TARGET BPM </span><span className="mt-0">80</span>
                                  </div>
                                </div>                           
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* <div className="swiper-pagination"></div> */}
                    <div className="swiper-btns">
                      <a href="javascript:void(0)" className="btn btn-outline-secondary swiper-btn-next">"Next"</a>
                      <a href="javascript:void(0)" className="btn btn-outline-secondary swiper-btn-prev d-none">"Prev"</a>
                    </div>
                  </div>                  
                </div>
              </div> 
            </div>
            
          </div>):( 
          <div className="d-flex height-script h-100 justify-content-end flex-direction-column position-relative">
            <div className="animate-display bg-gray position-relative top-rounded d-md-flex justify-content-between align-items-center px-3 py-3 add-remove-round ">
                <h3 className="main-heading font-size-16">Fitness Script <span className="ml-md-4 font-size-16"><span id="fitness-counter">0</span>/{sessionScript.length} {localstoragedata.sessionData.scriptType}</span></h3>
                <a href="javascript:void(0)" className=" mr-5 show-hide-script"><img src="./images/showscript.png" /></a>
                
              </div>
          <div className="bg-gray bottom-rounded px-3 pb-2 item-description script-section mt--1 flex-grow-1">
                      <div className="h-100"></div>
                    </div> 
            </div>
                  )}

          </div>
        </div>        
      </div>     
    </div>
    </div>
 
      <input type="hidden" id="switch-counter" />
      <input type="hidden" id="selected-participent-id" value="" />
      <input type="hidden" id="to-broadcast" />
      <input type="hidden" id="current-camera" />
      <input type="hidden" id="current-microphone" />

      {/* SESSION STARTED MODAL */}
    
      <span className="d-none" id="host-subscribers-list"></span>

    <div className="overlay-box" id="overlay"></div>
{/* {this.state.isTutorialRead===1 && localStorage.getItem('readTutorial') === null ?
      <div className="overlay-box" id="overlay"></div>
      :''} */}

  </div>
    );
  }
}
Host.propTypes = {
  logoutUser:PropTypes.func.isRequired,
  addLogs: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(
  mapStateToProps,
  { logoutUser, addLogs }
)(Host);